import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=d8161d4e&scoped=true"
import script from "./AgreementPopup.vue?vue&type=script&lang=js"
export * from "./AgreementPopup.vue?vue&type=script&lang=js"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&id=d8161d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8161d4e",
  null
  
)

export default component.exports